import {
  LocalStorageKey,
  LocalStorageValue,
  localStorageSchema,
} from './localStorageSchema'
import { validatedLocalStorage } from './validatedLocalStorage'

export function getLocalStorageItem<K extends LocalStorageKey>(
  key: K,
): LocalStorageValue<K> {
  return validatedLocalStorage.getItem(key, localStorageSchema[key])
}
